var React = require('react');

function Projects (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.833 13.25l1.134.85a.5.5 0 0 1 0 .8L12.8 20.275a.5.5 0 0 1-.6 0L5.033 14.9a.5.5 0 0 1 0-.8l1.134-.85 6.033 4.525a.5.5 0 0 0 .6 0l6.033-4.525zM12.2 4.725a.5.5 0 0 1 .6 0l7.167 5.375a.5.5 0 0 1 0 .8L12.8 16.275a.5.5 0 0 1-.6 0L5.033 10.9a.5.5 0 0 1 0-.8z","fill":"currentColor","fillRule":"evenodd"}));
}

Projects.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25"};

module.exports = Projects;

Projects.default = Projects;
